// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"Ribbon_ribbon__3a-zj","is-new":"Ribbon_is-new__Ui2Ar","ribbon-top-right":"Ribbon_ribbon-top-right__2-qoM","old-ribbon":"Ribbon_old-ribbon__1g3iy"};